import { sharedVanillaSetup } from "app/scripts/shared_vanilla_setup"
import Explore from "app/components/explore/index"

import "stylesheets/explore.scss"

sharedVanillaSetup()

document.addEventListener("DOMContentLoaded", function() {
  Explore()
}, { once: true })
